var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class ActionSkippedError extends Error {
}
/**
 * This queue waits until the current promise is resolved and only executes the last enqueued
 * promise. Promises added between the last and the currently executing promise are skipped.
 * This is useful when promises earlier enqueued become obsolete.
 * See also: https://stackoverflow.com/questions/53540348/js-async-await-tasks-queue
 */
export class LastQueue {
    constructor(throttlePeriod = 1000, rejectSkipped = false) {
        Object.defineProperty(this, "throttlePeriod", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /** Throw an error if a queued action is skipped. This avoids dangling promises */
        Object.defineProperty(this, "rejectSkipped", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "queuedPromises", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "pendingPromise", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        this.throttlePeriod = throttlePeriod;
        this.rejectSkipped = rejectSkipped;
    }
    skipPromise(key) {
        if (!this.rejectSkipped) {
            return;
        }
        const promise = this.queuedPromises[key];
        promise === null || promise === void 0 ? void 0 : promise.reject(new ActionSkippedError());
    }
    enqueue(action, arg, key = 0) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                this.skipPromise(key);
                this.queuedPromises[key] = { action, arg, resolve, reject };
                this.dequeue();
            });
        });
    }
    dequeue() {
        return __awaiter(this, void 0, void 0, function* () {
            const keys = Object.keys(this.queuedPromises);
            if (!this.pendingPromise && keys.length > 0) {
                const nextKey = keys[0];
                const item = this.queuedPromises[nextKey];
                delete this.queuedPromises[nextKey];
                this.pendingPromise = true;
                try {
                    const payload = yield item.action(item.arg);
                    item.resolve(payload);
                }
                catch (e) {
                    item.reject(e);
                }
                finally {
                    setTimeout(() => {
                        this.pendingPromise = false;
                        this.dequeue();
                    }, this.throttlePeriod);
                }
            }
        });
    }
}
